<div class="m-4">
  <form [formGroup]="summaryDisplayForm" class="pb-5">
    <div class="p-fluid p-formgrid mt-4">
      <div class="row" class="font-weight-bold mb-4 lead">
        Company Details
        <button type="button"  [disabled]="disableFields"
            (click)="editSection(0)" 
            class="p-button-text p-button-rounded  float-right im-btn im-btn-with-icon im-btn-outline-primary button_whitebg ">
            Edit <span class="ml-2"><i class="fa fa-pencil"></i></span>
        </button>
      </div>
      <div class="row">
        <div class="col-3 pl-0">
          <label class="mb-0 font-weight-bold">Company/Organization</label>
          <p> {{  this.getComanyData ?  this.getComanyData : '-'}}</p>
        </div>
        <div class="col-3">
          <label class="mb-0 font-weight-bold">Business Type</label>
          <p>
            <span *ngFor="let data of this.getBusinessTpe; let i = index">
              {{data.name}} {{i === this.getBusinessTpe.length -1 ? '' : ',&nbsp; ' }}
            </span>
            <span *ngIf="summaryDisplayForm.value.othername;">
              {{", Other : " + summaryDisplayForm.value.othername}} 
            </span>
          </p>
          <p> {{ this.getBusinessTpe ? this.getBusinessTpe : '-'}}</p>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-3 pl-0">
          <label class="mb-0 font-weight-bold">Incorporation Location</label>
          <p> {{ this.incorporationLocationData ? this.incorporationLocationData : '-'}}</p>
        </div>
        <div class="col-3">
          <label class="mb-0 font-weight-bold">Establishment Date</label>
          <p> {{ this.establishmentDateData  ? this.establishmentDateData : '-' }}</p>
        </div>
        <div class="col-3">
          <label class="mb-0 font-weight-bold">No. of Employees in U.S.</label>
          <p> {{ this.noOfEmployeesData ? this.noOfEmployeesData : '-'}}</p>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-3 pl-0">
          <label class="mb-0 font-weight-bold">NAICS Code</label>
          <p> {{ this.naicsCodeData ? this.naicsCodeData : '-' }}</p>
        </div>
        <div class="col-3">
          <label class="mb-0 font-weight-bold">FEI Number</label>
          <p> {{ this.feiNumberData ? this.feiNumberData : '-'}}</p>
        </div>
      </div>
    </div>
    <div class="p-fluid p-formgrid mt-4">
      <div class="row" class="font-weight-bold mb-4 lead">
        Petitioner Roles
        <button type="button"  [disabled]="disableFields"
        (click)="editSection(2)" 
        class="p-button-text p-button-rounded  float-right im-btn im-btn-with-icon im-btn-outline-primary button_whitebg ">
        Edit <span class="ml-2"><i class="fa fa-pencil"></i></span>
    </button>
      </div>
      <div class="card">
      <p-table [columns]="origColumns" [value]="roleDataSource" [scrollable]="true"  scrollHeight="400px" scrollDirection="both">
        <ng-template pTemplate="header">
          <tr>
            <th>Permission</th>
            <th *ngFor="let col of origColumns" class="text-center">
              {{col.columnDef}}
          </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-doc let-columns="columns">
          <tr>
            <td>
            <span>
              {{ doc.perm_name}}
            </span>
          </td>
          <td *ngFor="let col of columns" class="text-center">
            <div class="text-center width-100">
            <div [class.green_tick]="doc[col.columnDef] == true" class="perm_box"
              [class.grey_cross]="doc[col.columnDef] == false">
              <i class="pi pi-check" *ngIf="doc[col.columnDef] == true"></i>
              <i class="pi pi-times" *ngIf="doc[col.columnDef] == false"></i>
            </div>
          </div>
          </td>
            
              
              <!-- <mat-checkbox [checked]="row[doc.columnDef]" disabled class="bordered-checkbox"></mat-checkbox> -->
            
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
              <td colspan="12">No Data</td>
          </tr>
      </ng-template>
      </p-table>
    </div>
    </div>
    <div class="p-fluid p-formgrid mt-4">
      <div class="row" class="font-weight-bold mb-4 lead">
        List of Users
        <button type="button" 
        (click)="editSection(3)"  [disabled]="disableFields"
        class="p-button-text p-button-rounded  float-right im-btn im-btn-with-icon im-btn-outline-primary button_whitebg ">
        Edit <span class="ml-2"><i class="fa fa-pencil"></i></span>
    </button>
      </div>
      <p-table emptyMessage="Drag & Drop Placeholder" [value]="listOfUserData">
        <ng-template pTemplate="header">
          <tr>
            <th colspan="4">Users</th>
            <th colspan="4">Roles</th>
            <th colspan="4">Email</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-doc>
          <tr>
            <td colspan="4" >
              <div class="d-inline-block">{{doc.empName}} </div>
            </td>
            <td colspan="4" >
              <div class="d-inline-block">{{doc.roleNames}} </div>
            </td>
                
            <td colspan="4">
              <div class="d-inline-block">{{doc.email ? doc.email : '-'}} </div>
            </td>  
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
              <td colspan="12">No Data</td>
          </tr>
      </ng-template>
      </p-table>
      </div>
      <div class="p-fluid p-formgrid mt-4">
        <div class="row" class="font-weight-bold mb-4 lead">
          Beneficiaries to be Created
          <button type="button" 
          (click)="editSection(4)" [disabled]="disableFields"
          class="p-button-text p-button-rounded  float-right im-btn im-btn-with-icon im-btn-outline-primary button_whitebg ">
          Edit <span class="ml-2"><i class="fa fa-pencil"></i></span>
      </button>
        </div>
        <p-table [value]="listOfCreatedBeneficiariesData">
          <ng-template pTemplate="header">
            <tr>
              <th colspan="4">Name</th>
              <th colspan="4">Date Of Birth</th>
              <th colspan="4">Email</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-doc>
            <tr>
              <td colspan="4">
                <div class="d-inline-block">{{doc.empName}} </div>
              </td>
              <td colspan="4">
                <div class="d-inline-block">{{doc.dob  | date: 'MM/dd/yyyy'}} </div>
              </td>
                  
              <td colspan="4">
                <div class="d-inline-block">{{doc.email ? doc.email : '-'}} </div>
              </td>  
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="12">No Data</td>
            </tr>
        </ng-template>
        </p-table>
        </div>  
        <div class="p-fluid p-formgrid mt-4">
          <div class="row" class="font-weight-bold mb-4 lead">
            Beneficiaries to be Invited
            <button type="button" 
            (click)="editSection(4)" [disabled]="disableFields"
            class="p-button-text p-button-rounded  float-right im-btn im-btn-with-icon im-btn-outline-primary button_whitebg ">
            Edit <span class="ml-2"><i class="fa fa-pencil"></i></span>
        </button>
          </div>
          <p-table [value]="listOfInvitedBeneficiariesData">
            <ng-template pTemplate="header">
              <tr>
                <th colspan="4">Name</th>
                <th colspan="4">User ID</th>
                <th colspan="4">Email</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-doc>
              <tr>
                <td colspan="4">
                  <div class="d-inline-block">{{doc.name}} </div>
                </td>
                <td colspan="4">
                  <div class="d-inline-block">{{doc.userId ? doc.userId : '-'}}</div>
                </td>
                    
                <td colspan="4">
                  <div class="d-inline-block">{{doc.mail ? doc.mail : '-'}} </div>
                </td>  
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                  <td colspan="12">No Data</td>
              </tr>
          </ng-template>
          </p-table>
          </div>   
          <div class="row mt-2">
            <div class="col-6"></div>
            <div class="col text-right">
              <button (click)="onCancel()" pButton type="button" class="align-top mr-4 p-button-secondary">
                Cancel
              </button>
      
              <div class="border-right d-inline-block mr-4" style="height:46px"></div>
              <button (click)="onPrevious()" class="im-btn im-btn-primary im-btn-md">
                Previous
              </button>
              <button (click)="onSubmit()" type="submit" class="im-btn im-btn-primary im-btn-md mx-2">
                Finish
              </button>
            </div>
          </div>   
  </form> 
</div>